import { makeStyles } from '@mui/styles';
const vehiclePriceStyles = makeStyles(() => ({
    container: {},
    primaryContent: {
        fontWeight: 'bold',
        display: 'inline-block',
    },
    secondaryContent: {
        fontWeight: 'bold',
        marginRight: 32,
    },
    ivaLabel: {
        display: 'inline',
        fontWeight: 700,
    },
}), { name: 'Common_VehiclePrice' });
export default vehiclePriceStyles;
//# sourceMappingURL=vehiclePrice.styles.js.map